(function () {
  'use strict';
  angular.module('MktzapApp.Factories')
    .factory('ChatBotMessagesService', ChatBotMessagesService);

  ChatBotMessagesService.$inject = ['$resource'];

  function ChatBotMessagesService ($resource) {
	        return $resource('', {}, {
      getMessages: { url: apiUrl + '/get-chatbot-messages', method: 'GET', params: {}, isArray: true },
      saveMessages: { url: apiUrl + '/saveorupdate-chatbot-messages', method: 'POST', params: {}, isArray: false },
      deleteMessages: { url: apiUrl + '/delete-chatbot-messages', method: 'DELETE', params: {}, isArray: false }
	        });
	    }
})();
